import * as React from 'react';

export default function MinglAppLogo({
  width,
  maxWidth,
}: {
  width: string;
  maxWidth?: string;
}) {
  return (
    <div style={{ width, maxWidth }}>
      <div
        style={{
          backgroundImage: `url("${require('../../assets/img/Mingl_Icon_Blue.png')}"`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          paddingBottom: '100%',
          borderRadius: '20%',
        }}
      />
    </div>
  );
}
